import {
    gql
} from "@apollo/client";

export const RETRIEVE_PRODUCT_BY_ID = gql`
    query gqlRetrieveProductById($nID: Int!) {
        data: gqlRetrieveProductById(nID: $nID) {
            nID
            bIsActive
            sNameKey
            sDescriptionKey
            categories {
                nIDCategory
                nIDSubcategory
            }
            sImages
            languages
            sAllergens
            sLabels
            nPrice
            nIDDays
            prices {
                nIDType
                nPrice
            }
        }
    }
`;

export const RETRIEVE_PRODUCTS = gql`
    query gqlRetrieveProducts($nIDRestaurant: Int!) {
        data: gqlRetrieveProducts(nIDRestaurant: $nIDRestaurant) {
            nID
            sNameKey
            sDescriptionKey
            nIDDays
            sCategories {
                nIDCategory
                nIDSubcategory
                sCategory
                sSubcategory
            }
            sImages
            languages
            sAllergens
            sLabels
            nPrice
            bIsStar
        }
    }
`;

export const RETRIEVE_TOP_PICKS = gql`
    query gqlRetrieveTopProducts($nIDRestaurant: Int!) {
        data: gqlRetrieveTopProducts(nIDRestaurant: $nIDRestaurant) {
            nID
            sImages
            languages
            nPrice
        }
    }
`;

export const RETRIEVE_PRODUCTS_BY_CATEGORY_ID = gql`
    query gqlRetrieveProductsByCategoryId($nIDRestaurant: Int!, $nID: Int!) {
        data: gqlRetrieveProductsByCategoryId(nIDRestaurant: $nIDRestaurant, nID: $nID) {
            nID
            sNameKey
            sDescriptionKey
            sImages
            languages
            sAllergens
            sLabels
            nPrice
            nIDDays
            sCategories {
                nIDCategory
                nIDSubcategory
                sCategory
                sSubcategory
            }
            prices {
                nIDType
                nPrice
            }
        }
    }
`;